import { SSRPrepareErrorsClient } from '../src/SSRPrepareErrorsClient';

export const ssrPrepareErrorsClient = new SSRPrepareErrorsClient();
